import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';

export const useGetScheduleVisibility = (moduleProjectId?: string, studentId?: string) => {
    const [showSchedule, setShowSchedule] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [settingsId, setSettingsId] = useState<string>('');
    const [moduleId, setModuleId] = useState<string>('');

    useEffect(() => {
        if (!moduleProjectId || !studentId) return;
        let isCancelled = false;
        setIsLoading(true);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModuleUserSettings')
            .addQuery('moduleProjectId', moduleProjectId)
            .addQuery('studentId', studentId)
            .get()
            .send()
            .then((r: any) => r.json())
            .then((r: any) => {
                if (!isCancelled) {
                    setShowSchedule(!!r?.showLessonsSchedule);
                    setSettingsId(r?.id || '');
                    setModuleId(r?.moduleId || '');
                    setIsLoading(false);
                }
            })
            .catch(() => {
                if (!isCancelled) setIsLoading(false);
            });

        return () => { isCancelled = true; };
    }, [moduleProjectId, studentId]);

    return { showSchedule, isLoading, settingsId, moduleId };
};
import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';

export const useGetScheduleVisibility = (moduleProjectId?: string, studentId?: string) => {
    const [showSchedule, setShowSchedule] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [settingsId, setSettingsId] = useState<string>('');
    const [moduleId, setModuleId] = useState<string>('');

    useEffect(() => {
        if (!moduleProjectId || !studentId) return;
        let isCancelled = false;
        setIsLoading(true);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModuleUserSettings')
            .addQuery('moduleProjectId', moduleProjectId)
            .addQuery('studentId', studentId)
            .get()
            .send()
            .then((r: any) => r.json())
            .then((r: any) => {
                if (!isCancelled) {
                    setShowSchedule(!!r?.showLessonsSchedule);
                    setSettingsId(r?.id || '');
                    setModuleId(r?.moduleId || '');
                    setIsLoading(false);
                }
            })
            .catch(() => {
                if (!isCancelled) setIsLoading(false);
            });

        return () => { isCancelled = true; };
    }, [moduleProjectId, studentId]);

    return { showSchedule, isLoading, settingsId, moduleId };
};
